export const scrollToTop = () => {
  window.scrollTo(0, 0);
}

export default {
  scrollToTop,
}



// WEBPACK FOOTER //
// ./src/utils/Link.js